import { useEffect, useState } from "react";

export default function Alert() {
    const defaultValue = !localStorage.getItem('showAlert') || localStorage.getItem('showAlert') === 'true';
    const [visible, setVisible] = useState(defaultValue);

    const handleClick = (e) => { setVisible(false); }

    const clearLocalStorage = (e) => {
        e.preventDefault();
        localStorage.clear();
        setVisible(true);
    }

    useEffect(() => {
        localStorage.setItem('showAlert', visible);
    }, [visible])

    return (
        <>
            {visible && 
                <div className="alert alert-info alert-dismissible fade show w-25 position-fixed bottom-0 end-0 me-2" role="alert">
                    <strong>Looking for a glbta+ fleet?</strong> Check out <a target="_blank" rel="noreferrer" href="https://fleet.stonewallgaming.net">Stonewall Fleet</a>.
                    <button type="button" onClick={handleClick} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            }

            {window.location.hostname === 'localhost' && !visible &&
                <div className="position-fixed bottom-0 end-0">
                    <button onClick={clearLocalStorage}>Clear localStorage</button>
                </div>
            }
        </>
    )
}